type CookieConsent = {
  decided: boolean
  analytics: boolean
  marketing: boolean
}

export function useCookieConsent() {
  // 1 year, lax is a sane default for consent cookies
  const consent = useCookie<CookieConsent>('cookie_consent', {
    default: () => ({ decided: false, analytics: true, marketing: true }),
    maxAge: 60 * 60 * 24 * 365,
    sameSite: 'lax',
  })

  const showModal = computed(() => !consent.value.decided)

  function acceptAll() {
    consent.value = { decided: true, analytics: true, marketing: true }
  }

  function rejectAll() {
    consent.value = { decided: true, analytics: false, marketing: false }
  }

  function savePreferences(next: Omit<CookieConsent, 'decided'>) {
    consent.value = { decided: true, ...next }
  }

  function reopen() {
    // optional: open modal again without forgetting the choices
    // (or set decided=false if you want to force a re-choice)
    consent.value = { ...consent.value, decided: false }
  }

  return { consent, showModal, acceptAll, rejectAll, savePreferences, reopen }
}
